import { defineAction } from '~/prix'
import { z } from 'zod'
import requirementReportAction from './requirementReport.action.json' with { type: 'json' }
import { requirementReportTypeSchema } from './requirementReportShared'

const requirementReportDefinition = defineAction({
  ...requirementReportAction,

  input: z.object({
    id: z.string().uuid().optional(),
    reportType: requirementReportTypeSchema,
    format: z.literal('pdf').default('pdf'),
  }),
  output: z.any(),
})

export default requirementReportDefinition
